import React, { useEffect, useState, } from 'react'


function isSameSecond(time1, time2) {
  return Math.floor(time1 / 1000) === Math.floor(time2 / 1000)
}

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
function parseTimeData(time) {
  const days = Math.floor(time / DAY)
  const hours = Math.floor((time % DAY) / HOUR)
  const minutes = Math.floor((time % HOUR) / MINUTE)
  const seconds = Math.floor((time % MINUTE) / SECOND)
  const milliseconds = Math.floor(time % SECOND)
  return {
    days,
    hours,
    minutes,
    seconds,
    milliseconds
  }
}
function padZero(num, targetLength = 2) {
  let str = `${num}`
  while (str.length < targetLength) {
    str = `0${str}`
  }
  return str
}
function parseFormat(format, timeData) {
  let {
    days,
    hours,
    minutes,
    seconds,
    milliseconds
  } = timeData
  // 如果格式化字符串中不存在DD(天)，则将天的时间转为小时中去
  if (format.indexOf('DD') === -1) {
    hours += days * 24
  } else {
    // 对天补0
    format = format.replace('DD', padZero(days))
  }
  // 其他同理于DD的格式化处理方式
  if (format.indexOf('HH') === -1) {
    minutes += hours * 60
  } else {
    format = format.replace('HH', padZero(hours))
  }
  if (format.indexOf('mm') === -1) {
    seconds += minutes * 60
  } else {
    format = format.replace('mm', padZero(minutes))
  }
  if (format.indexOf('ss') === -1) {
    milliseconds += seconds * 1000
  } else {
    format = format.replace('ss', padZero(seconds))
  }
  return format.replace('SSS', padZero(milliseconds, 3))
}

export default function Countdown(props) {
  const { time = 0, style = {}, finish, change } = props;
  const [formattedTime, setFormattedTime] = useState(0); // 剩余的毫秒时间
  let timer = null;
  let endTime = 0;// 结束的毫秒时间戳
  let remainTime = 0;// 剩余的毫秒时间

  const start = () => {
    // 结束时间戳 = 此刻时间戳 + 剩余的时间
    endTime = Date.now() + time
    macroTick()
  }
  const reset = () => {
    clearTimeout(timer)
    timer = null
  }

  const setRemainTime = (remain) => {
    remainTime = remain
    // 根据剩余的毫秒时间，得出该有天，小时，分钟等的值，返回一个对象
    const timeData = parseTimeData(remain)
    typeof change === 'function' && change(timeData)
    // 得出格式化后的时间
    setFormattedTime(parseFormat('HH:mm:ss', timeData))
    // 如果时间已到，停止倒计时
    if (remain <= 0) {
      typeof reset === 'function' && reset()
    }
  }
  const macroTick = () => {
    reset()
    // 每隔一定时间，更新一遍定时器的值
    // 同时此定时器的作用也能带来毫秒级的更新
    timer = setTimeout(() => {
      // 获取剩余时间
      const remain = Math.max(endTime - Date.now(), 0)
      // 重设剩余时间
      if (!isSameSecond(remain, remainTime) || remain === 0) {
        setRemainTime(remain)
      }
      // 如果剩余时间不为0，则继续检查更新倒计时
      if (remainTime !== 0) {
        macroTick()
      }
    }, 30)
  }

  useEffect(() => {
    start()
    return () => {
      reset()
    }
  }, [])

  return (
    <div style={{ color: '#FF6600', fontSize: '24px', lineHeight: '26px', ...style }}>
      {formattedTime}
    </div>
  );
}
